import { Box, Divider, Flex, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import fetchOrder from "areas/order/hoc/fetch-order"
import { AddonCartProvider } from "contexts/addon-cart"
import { jewlr_t } from "helpers/application"

import Cart from "./cart"

const Title = styled(Typography).attrs({
  as: "h1",
})`
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  margin-bottom: 16px;
  margin-top: 32px;
  ${(props) => props.theme.mediaQueries.desktop`
    margin-bottom: 32px;
    margin-top: 48px;
  `}
`

const GiftPackaging = ({ data, loading }) => {
  if (!data || loading) {
    return (
      <Flex justifyContent="center" m="auto">
        <Image
          alt="Loading..."
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </Flex>
    )
  } else if (data.errors) {
    return (
      <Flex alignItems="center" contain flexDirection="column" my={4}>
        {data.errors.map((error, i) => (
          <Typography
            fontSize={20}
            fontWeight={600}
            key={i}
            mb={4}
            textAlign="center"
          >
            {error}
          </Typography>
        ))}
        <Typography fontSize="18px" mb={4} textAlign="center">
          Thank you for choosing {sl.config.site_title}.
        </Typography>
        <Box
          as={Link}
          bg="primary"
          color="white"
          data-lc="gift-packaging"
          fontSize={14}
          p="12px 20px"
          to="/"
        >
          CONTINUE SHOPPING
        </Box>
      </Flex>
    )
  }

  return (
    <AddonCartProvider>
      <Title>Add Gift Packaging</Title>
      <Typography
        fontSize="16px"
        fontWeight="300"
        letterSpacing="-0.02em"
        lineHeight="22px"
        pb={2}
      >
        Upgrade your order with {jewlr_t("terms.personalized")} gift packaging
        options.
      </Typography>
      <Divider bg="grey.20" my={2} />
      <Cart line_items={data.line_items} />
    </AddonCartProvider>
  )
}

GiftPackaging.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
}

export default fetchOrder(GiftPackaging)
